import styled, { css } from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

import { PlayerPositionLong } from '~/core/enums';
import { WithIsHome } from '~/core/styleTypes';

export const IceSheetContainer = styled.div`
    background: ${({ theme }) => theme.Surface.secondary};
    border: 1px solid ${({ theme }) => theme.Surface.border};
    border-radius: 4px;
    position: relative;
`;

export const PlayerGridContainer = styled.div`
    position: absolute;
    height: 100%;
    width: 100%;
    bottom: 0;
    display: grid;
    grid-template-rows: 32px 1fr 36px;
    grid-template-columns: 1fr 3fr 2fr 2fr 2fr 2fr 2fr 2fr 3fr 1fr;
    grid-template-areas:
        'bench bench bench bench bench bench bench bench bench bench'
        '. awayGoalie awayDefense awayForwards . . homeForwards homeDefense homeGoalie .'
        '. . awayPenaltyBox awayPenaltyBox awayPenaltyBox homePenaltyBox homePenaltyBox homePenaltyBox . .';
    align-items: center;
    justify-items: center;

    ${BaseStyle.Mixins.screenSizes.small} {
        grid-template-rows: 26px 1fr 28px;
    }

    ${BaseStyle.Mixins.screenSizes.medium} {
        grid-template-rows: 56px 1fr 56px;
    }
`;

const getPositionGroup = (isHome, position?: PlayerPositionLong) => {
    switch (position) {
        case PlayerPositionLong.forwards:
            return isHome ? 'homeForwards' : 'awayForwards';
        case PlayerPositionLong.defensemen:
            return isHome ? 'homeDefense' : 'awayDefense';
        case PlayerPositionLong.goalies:
            return isHome ? 'homeGoalie' : 'awayGoalie';
        default:
            return isHome ? 'homePenaltyBox' : 'awayPenaltyBox';
    }
};

export const PositionGroup = styled.div<WithIsHome & { $position?: PlayerPositionLong }>`
    grid-area: ${({ $isHome, $position }) => getPositionGroup($isHome, $position)};
    height: 100%;
    display: grid;
    align-content: space-evenly;
    justify-self: ${({ $isHome, $position }) => (!$position ? ($isHome ? 'start' : 'end') : 'center')};
    padding: 0 10px;

    ${({ $position }) =>
        !$position &&
        css`
            display: flex;
            align-items: center;
        `};
`;
